import { useEffect, useState } from "react";
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { Tooltip } from "../../components/utils/Tooltip";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useModal } from "../../../hooks/useModal";
import { Modal } from "../../components/modal/Modal";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { SwitchToggle } from "../../components/SwitchToggle";
import { notify, obtenerEstado } from "../../../utils/utils";

export const InventarioSubDominios = ()  => {

    const [ valorEstado, setValorEstado ] = useState(0);
    const [ isOpenModalSubDominio, openModalSubDominio, closeModalSubDominio ] = useModal(null);
    const [ isOpenModalEliminarSubDominio, openModalEliminarSubDominio, closeModalEliminarSubDominio ] = useModal(null);
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }

    const idTabla = 'TablaSubDominio'
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    const {
        listarEstados,
        listaEstadoConocimiento,
        listarSubDominios,
        subDominios,
        listarDetalleSubDominio,
        detalleSubDominio,
        editarValorSubDominio,
        listarDominiosCombo,
        listaDominios,
        guardarEditarSubdominio,
        listarProveedorSSL,
        listaProveedorSSL,
        eliminarSubDominio

    } = useGestionConocimientos()

    const registrarSubDominio = async () =>{
        const camposAValidar = [ "nomSubDominio", "codGestionInfraestructuraDominio", "fechaCreacion","codProveedorSSL"]
        const validarRegistro = camposAValidar.some(campo => detalleSubDominio[campo] === "" || detalleSubDominio[campo] === null || detalleSubDominio[campo] === 0 || detalleSubDominio[campo] === undefined);
        if(validarRegistro){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await guardarEditarSubdominio();
        if(isValid)
        {
            listarSubDominios(valorEstado);
            closeModalSubDominio();
        }
    }

    const eliminarRegistro = async () => {
        const camposAValidar = ["motivoEliminacion"];
        const validarEliminacion = camposAValidar.some(campo => datosEliminar[campo] === "" || datosEliminar[campo] === null || datosEliminar[campo] === 0 || datosEliminar[campo] === undefined);
        if(validarEliminacion){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await eliminarSubDominio(detalleSubDominio.codGestionInfraestructuraSubDominio, datosEliminar.motivoEliminacion);
        if(isValid)
        {
            await listarSubDominios(valorEstado);
            closeModalEliminarSubDominio();
        }
    }

    useEffect(() => {
        listarProveedorSSL();
        listarDominiosCombo();
        listarEstados();
        listarSubDominios(0);
    },[])

    return(
        <>
            <ContenedorParametros
                titulo='Inventario de subdominios'
                tablaId={idTabla}
            >
                <i className="fa fa-filter" data-tip="iconoEstado" data-for="iconoEstado"></i>
                <Tooltip id={"iconoEstado"}>Estados</Tooltip>
                <select
                    id="selectEstadoDominio"
                    className={classNameSelect}
                    value={valorEstado}
                    onChange={(e) => setValorEstado(Number(e.target.value))}
                >
                    <option key={'opcionTodos_Estado'} value={0}>--Todos--</option>
                    {
                        listaEstadoConocimiento.map(e => (
                            <option key={e.codEstado} value={e.codEstado}>{e.nomEstado}</option>
                        ))
                    }
                </select>
                <BotonNuevo
                    onClick={async () => {
                        listarDetalleSubDominio()
                        openModalSubDominio()
                    }}
                />
                <BotonProcesar
                    onClick={()=> listarSubDominios(valorEstado)}
                />
            </ContenedorParametros>
            <ContenedorTabla>
                <table id={idTabla} className="table">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            <th>NOMBRE</th>
                            <th>FECHA CREACIÓN</th>
                            <th>VENCIMIENTO SSL</th>
                            <th>PROVEEDOR SSL</th>
                            <th>ESTADO SSL</th>
                            <th>ESTADO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            subDominios.length > 0 ?
                                subDominios.map((sub, i) => (
                                    <tr key={`body_${i}`}>
                                        <td className="text-center w-[40px]">{i + 1}</td>
                                        <td className="text-center w-[90px]">
                                            <span className="px-2 bg-blue-600 rounded w-[70px] inline-block text-center">{sub.codigoDominio}</span>
                                        </td>
                                        <td className="w-[300px]">
                                            <div className="w-[95%] text-ellipsis overflow-hidden whitespace-nowrap">
                                                {sub.nomSubDominio}
                                            </div>
                                        </td>
                                        <td className="text-center">{sub.fechaCreacion}</td>
                                        <td className="text-center">{sub.expiracionSSL}</td>
                                        <td className="w-[300px] ">{sub.nomProveedorSSL}</td>
                                        <td className="text-center">
                                            {sub.nomEstadoSSL + ' '}
                                            <i
                                                className={`fa fa-circle ${sub.codEstadoSSL === 1 ? 'text-green-500' : 'text-red-500'}`}
                                            ></i>
                                        </td>
                                        <td className="text-center">{obtenerEstado(sub.codEstado,sub.nomEstado)}</td>
                                        <td>
                                            {
                                                sub.codEstado != 10 ? 
                                                    <i
                                                        className="fa fa-edit text-lg text-blue-600"
                                                        onClick={ async () => {
                                                            await listarDetalleSubDominio(sub);
                                                            openModalSubDominio()
                                                        }}
                                                    ></i>
                                                :
                                                    <></>
                                            }
                                        </td>
                                        <td>
                                        {
                                                sub.codEstado != 10 ? 
                                                    <i
                                                        className="fa fa-trash text-lg text-red-600"
                                                        onClick={ async () => {
                                                            await listarDetalleSubDominio(sub)
                                                            openModalEliminarSubDominio()
                                                        }}
                                                    ></i>
                                                :
                                                    <></>
                                            }
                                            
                                        </td>
                                    </tr>
                                ))
                            :
                            <tr>
                                <td colSpan={12} className="text-center">No hay información para mostrar...</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal
                isOpen={isOpenModalSubDominio}
                closeModal={closeModalSubDominio}
                action={()=> registrarSubDominio()}
                title={detalleSubDominio.codGestionInfraestructuraSubDominio === 0 ? "Nuevo registro de subdominio" : `Editar Subdominio [${detalleSubDominio.codigoDominio}]`}
            >
                <fieldset className="border-zinc-600 border rounded-md">
                    <legend className="mx-2">Sub Dominio</legend>
                    <section className=" grid grid-cols-[minmax(0,20fr)_minmax(0,30fr)_minmax(0,20fr)_minmax(0,30fr)] items-center gap-2 p-2">
                        <label htmlFor="nomSubDominio">Nombre</label>
                        <input
                            id="nomSubDominio"
                            className={classNameInput}
                            value={detalleSubDominio.nomSubDominio}
                            onChange={(e)=> editarValorSubDominio("nomSubDominio", e.target.value)}
                        />
                        <label htmlFor="codDominio">Dominio</label>
                        <select
                            id="codDominio"
                            className={classNameSelect}
                            value={detalleSubDominio.codGestionInfraestructuraDominio}
                            onChange={(e)=> editarValorSubDominio('codGestionInfraestructuraDominio', Number(e.target.value))}
                        >
                            <option value={0} key={'opcionSeleccioneDominio'}>--Seleccione--</option>
                            {
                                listaDominios.length > 0 ?
                                    listaDominios.map(dom => (
                                        <option key={dom.codGestionInfraestructuraDominio} value={dom.codGestionInfraestructuraDominio}>{dom.nomDominio}</option>
                                    ))
                                :
                                <></>
                            }
                        </select>
                        <label>Fecha creación</label>
                        <DatePickerABX
                            classNameInput={'bg-zinc-900 w-[195px]'}
                            ocultarIcono={true}
                            date={detalleSubDominio.fechaCreacion}
                            setDate={editarValorSubDominio}
                            keyDate={'fechaCreacion'}
                        />
                        <label>Expiración SSL</label>
                        <DatePickerABX
                            classNameInput={'bg-zinc-900 w-[195px]'}
                            ocultarIcono={true}
                            date={detalleSubDominio.expiracionSSL}
                            setDate={editarValorSubDominio}
                            keyDate={'expiracionSSL'}
                        />
                        <label htmlFor="proveedorSSL">Proveedor SSL</label>
                        <select
                            id="proveedorSSL"
                            className={classNameSelect}
                            value={detalleSubDominio.codProveedorSSL}
                            onChange={(e) => editarValorSubDominio('codProveedorSSL',Number(e.target.value))}
                        >
                            <option value={0} key={'opcionSeleccioneSSL'}>--Seleccione--</option>
                            {
                                listaProveedorSSL.length > 0 ? 
                                    listaProveedorSSL.map(ssl => (
                                        <option key={ssl.codProveedorSSL} value={ssl.codProveedorSSL}>{ssl.nomProveedorSSL}</option>
                                    ))
                                :
                                <></>
                            }
                        </select>
                        <label htmlFor="certificado">Certificado SSL</label>
                        <div>
                            <SwitchToggle
                                keyEdit={"certificadoSSL"}
                                setEdit={editarValorSubDominio}
                                valor={detalleSubDominio.certificadoSSL}
                            />
                        </div>
                        <label htmlFor="descripcionSubDominio">Descripción</label>
                        <textarea
                            id="descripcionSubDominio"
                            className={`${classNameInput} col-span-3 h-[80px] resize-none`}
                            value={detalleSubDominio.descripcion}
                            onChange={(e)=>editarValorSubDominio("descripcion", e.target.value)}
                        />
                    </section>

                </fieldset>
            </Modal>

            {/* MODAL PARA ELIMINAR SUBDOMINIO */}
            <Modal
                isOpen={isOpenModalEliminarSubDominio}
                closeModal={closeModalEliminarSubDominio}
                action={() => eliminarRegistro()}
                title={`Eliminar Lección y aprendizaje [${datosEliminar.codGestionConocimiento}]`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea
                        className={`${classNameInput}
                        h-[80px] resize-none`}
                        placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."
                        onChange={(e) => editarValorEliminacion('motivoEliminacion', e.target.value)}
                    />
                </div>
            </Modal>
        </>
    )
}